import React, { Component } from 'react';
import "./Searcher.scss";
import { MapboxService } from '../../../services/mapboxService';
import {domElements,valuesMap,isCanary} from '../../../utils/data';
import {StateHandlerService} from '../../../services/stateHandlerService';


export default class Searcher extends Component {
 
    constructor()  {
        super();

        this.state = {
          loading:false,
          messageNoResults : false,
          wordSearh:''
        }
        this.mapboxService = new MapboxService();

     
        this.stateService = new StateHandlerService();
       
      }
      componentDidMount() {
        this.mapboxService.map['addAutoComplete'](
          {
            autoCompleteInput:domElements().INPUT,
            countryCode:valuesMap().COUNTRY,
            onLocationSelect:this.onLocationSelect.bind(this)
          }
        )
      }
      async onLocationSelect(locations){
    
        if (locations){
    
          if (isCanary('',locations.region)){
            this.setState({loading:false, messageNoResults:true})

          }
    
          else {
            this.mapboxService.map['clearMarkers']()
            this.setState({loading:true})
            try {
            let dealers = await this.mapboxService.getDealersByCoords(locations.center)
            if(dealers){
           //   this.tagService.sendEventoSignalTag('dealers-results','1','0');
           this.setState({ messageNoResults:false})
           dealers = await dealers.json();
              dealers = this.mapboxService.getWorkshopsinDealers(dealers['dealers']);
              this.stateService.publishControls({start:0,end:Math.min(5,dealers['length'])})
              this.stateService.publishDealers(dealers);
              }
              else{
                this.setState({ messageNoResults:true})
                
              }
            }
            finally{
              this.setState({loading:false,})
            }
        
        
    
        }
      }
      }
     
      searchbyWord(){
        if (isCanary(this.state.wordSearh,this.state.wordSearh)){
          this.setState({loading:false})
          this.setState({ messageNoResults:true})

        }
        else {
          this.setState({ messageNoResults:false})
    
        this.setState({loading:true})
        this.mapboxService.map['geocoder'].search(this.state.wordSearh, 
          {countryCode:valuesMap().COUNTRY}
          ).then(res=>{
            if (res.length){
             
              this.onLocationSelect(res[0])
            }
            else {
              this.setState({loading:false})
              this.setState({ messageNoResults:true})
            }
          }
            )
            .catch(err=>{
              console.error(err);
              this.setState({loading:false})
            })
    
      }
    }
      async getMyUbication(){
          
         const coords= await this.mapboxService.getMyUbication();
         const place = await this.mapboxService.getPlaceByCoords(coords);
         if (isCanary('',place['region']||place['text'])){
          this.setState({loading:false})
          this.setState({ messageNoResults:true})

         }
         else this.onLocationSelect(coords)
        
      }
 
    render() {
    return (
        <div >
       

       
           <div>
    <p className="title-search" style={{ fontSize: "1.1rem", fontFamily: "'Nobel Regular',helvetica,arial,roboto,sans-serif;", fontWeight: "400" }}>Localiza tu concesionario más cercano</p>
    <div className="row-search">
        <div className="input-search">
            <input
            style={{ fontSize: "0.95rem", fontFamily: "'Nobel Regular',helvetica,arial,roboto,sans-serif;", fontWeight: "400" }}
            id="searcher-input" 
            autoComplete="off" 
            placeholder="Busca localidad o CP" 
            type="text" 
            value={this.state.wordSearh || ''}
            onChange={event => this.setState({ wordSearh: event.target.value})

          } 
            />
        </div>
        <div className="btn-search"    onClick={() => {this.searchbyWord() }}
                     >
            <span className="icon-search"></span>
        </div>
    </div>
   {this.state.messageNoResults?(<div className="messageNoResults" >No existen resultados</div>):null} 

  </div>
<div className="my-ubication-container" onClick={()=>{this.getMyUbication()}}>
    <div  className="icon-ubication"></div>
    <div   className="btn-ubication" >Desde mi posición actual</div>
   
   {!this.mapboxService.ubicationAllow?(<div className="warning-container">
        <img className="warning-img" src="./images/warning.png"/>
        <span className="tooltip">Ubicación bloqueada</span>
        </div>
   ):null} 
</div>
{/* {this.state.loading?(<div  className="img-loading"><img src="./images/loading.gif"/> Cargando... </div> ):null} */}
{this.state.loading?(<div  className="img-loading"><img src="./images/spinner.gif"/> Cargando... </div> ):null}


  


      </div>
    )
  }
}
